__turbopack_context__.v({
  "text": "t1NP6a_text",
  "wrapper": "t1NP6a_wrapper",
});
